import EventEmitter from "wolfy87-eventemitter";
import context from "../context";
class ToolkitManager extends EventEmitter{
    constructor(){
        super();
        // this.init()
    }
    init = ()=>{
        const {kits} = context.appConfig;
        let toolkits = [];
        kits&&kits.map(kit=>{
            this.addKit(kit).then(tool=>{
                // console.log(tool);
                toolkits.push(tool);
            })
        });
        context.toolkitManager = toolkits;
    }
    addKit = async (kit)=>{
        // console.log(`@/toolkits/${kit.path}`);
        const importComponent = ()=>import(`@/toolkits/${kit.path}`);
        // console.log(importComponent());
        const module = await importComponent();
        return new module.default();
    }
    getUI = ()=>{
        return context.toolkitManager.map(item=>{
          return item.getUI&&item.getUI();
        });
    }
}
export default ToolkitManager;